"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSwapModal = void 0;
var actions_1 = require("../context/actions");
var context_1 = require("../context/context");
var lib_1 = require("./lib");
var useSwapModal = function () {
    var _a = (0, context_1.useTwapContext)(), state = _a.state, srcToken = _a.srcToken, dstToken = _a.dstToken;
    var swapState = state.swapState, isOpen = state.showConfirmation, swapData = state.swapData;
    var _b = actions_1.stateActions.useSwapModalActions(), onClose = _b.onClose, onOpen = _b.onOpen;
    var srcAmountUi = (0, lib_1.useSrcAmount)().amountUi;
    var _c = (0, lib_1.useUsdAmount)(), srcUsd = _c.srcUsd, dstUsd = _c.dstUsd;
    var outAmount = (0, lib_1.useOutAmount)().amountUi;
    return {
        onClose: onClose,
        onOpen: onOpen,
        isOpen: isOpen,
        swapState: swapState,
        srcAmount: (swapData === null || swapData === void 0 ? void 0 : swapData.srcAmount.amountUi) || srcAmountUi,
        srcUsd: (swapData === null || swapData === void 0 ? void 0 : swapData.amountUsd.srcUsd) || srcUsd,
        dstUsd: (swapData === null || swapData === void 0 ? void 0 : swapData.amountUsd.dstUsd) || dstUsd,
        outAmount: (swapData === null || swapData === void 0 ? void 0 : swapData.outAmount.amountUi) || outAmount,
        srcToken: (swapData === null || swapData === void 0 ? void 0 : swapData.srcToken) || srcToken,
        dstToken: (swapData === null || swapData === void 0 ? void 0 : swapData.dstToken) || dstToken,
    };
};
exports.useSwapModal = useSwapModal;
